import {NgModule} from '@angular/core';
import {ExchangesService} from './exchanges/exchanges.service';
import {SecurityStreamingModule} from './security-streaming/security-streaming.module';
import {SecurityService} from './security.service';

@NgModule({
    imports: [
        SecurityStreamingModule
    ],
    providers: [
        SecurityService,
        ExchangesService
    ]
})
export class SecurityModule {}
